import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import PaymentModal from "./PaymentModal";
import ReportImageModal from "./ReportImageModal";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import DownloadIcon from "@mui/icons-material/Download";
import { getGraphData, getGraphDetails, getViewReport } from "../../api/api";
import GraphList from "./GraphList";
import CustomLoader from "../../common/loader/CustomLoader";
import GraphDetailsModal from "./GraphDetailsModal";
import { number } from "framer-motion";
import { PDFDocument } from "pdf-lib";
import toast from "react-hot-toast";
import { getBillIdWiseDownload } from "../../api/api";
import { useNavigate, useSearchParams } from "react-router-dom";
import { parseBillId } from "../../utils/helper";

const ShowReport = () => {
  const [openModal, setOpenModal] = useState(false);
  
  const [openImageModal, setOpenImageModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [showGraphList, setShowGraphList] = useState(false);
 
  const [graphData, setGraphData] = useState([]);
  const [graphDetails, setGraphDetails] = useState([]);
  const [graphModal, setGraphModal] = useState(false);
  const [userId, setUserId] = useState("");
const [searchParams] = useSearchParams();
const navigate = useNavigate();

const billId = searchParams.get("billid");
const lastName = searchParams.get("lastname");
const [reports, setReports] = useState([]);
const [loading, setLoading] = useState(false);


  // Handle case when reports is undefined or empty

  // if (!reports || reports.length === 0) {
  //   return (
  //     <Typography variant="body1" textAlign="center" mt={3}>
  //       No reports found.
  //     </Typography>
  //   );
  // }


  useEffect(() => {
  if (!billId || !lastName) {
    toast.error("Invalid or missing report details");
    navigate("/view-reports");
    return;
  }

  fetchReports();
}, [billId, lastName]);

const fetchReports = async () => {
    // const billId = `${formData.char}${formData.digit1}-${formData.digit2}`;

    const payload = {
      RBAuthKey: "RBDWAh!Q1s74e",
      Bill_id: billId,
      FYear: parseBillId(billId)?.financialYear || "",
      sur_name: lastName,
    };

    try {
      setLoading(true); 
      const response = await getViewReport(payload);
      console.log("View Report Response:", response);

      const reports = response?.data?.data;

      if (Array.isArray(reports) && reports.length > 0) {
        setReports(reports);
      } else {
        const msg =
          response?.data?.message?.toString() ||
          "No reports found for given details!";
        toast.error(msg);
      }
    } catch (error) {
      console.error("Error fetching reports:", error);
      toast.error("Something went wrong. Please try again later!");
    } finally {
      setLoading(false); 
    }
  };





  const handlePayNow = () => {
    setOpenModal(true);
  };

  
  const embedImageToPdf = async (pdfDoc, imageUrl) => {
  const res = await fetch(imageUrl);
  const bytes = await res.arrayBuffer();

  let image;
  if (imageUrl.toLowerCase().endsWith(".png")) {
    image = await pdfDoc.embedPng(bytes);
  } else {
    image = await pdfDoc.embedJpg(bytes);
  }

  const page = pdfDoc.addPage([image.width, image.height]);
  page.drawImage(image, {
    x: 0,
    y: 0,
    width: image.width,
    height: image.height,
  });
};


//  const handleDownloadAllReports = async (reports) => {
//   setLoading(true);

//   try {
//     const mergedPdf = await PDFDocument.create();

    
//     const uniqueUrls = new Set();

//     for (const report of reports) {
//       const imageUrl = report.report_image_url;
//       if (!imageUrl || uniqueUrls.has(imageUrl)) continue;

//       uniqueUrls.add(imageUrl);

//       try {
//         const resp = await getBillIdWiseDownload({
//           printUrl: imageUrl,
//         });

//         if (resp?.data?.status !== "success" || !resp.data.data) {
//           throw new Error("Invalid PDF response");
//         }

//         let arrayBuffer;
//         const fileData = resp.data.data;

        
//         if (typeof fileData === "string" && fileData.startsWith("data:")) {
//           const base64 = fileData.split(",")[1];
//           const byteChars = atob(base64);
//           const byteNumbers = new Uint8Array(byteChars.length);

//           for (let i = 0; i < byteChars.length; i++) {
//             byteNumbers[i] = byteChars.charCodeAt(i);
//           }

//           arrayBuffer = byteNumbers.buffer;
//         }
       
//         else {
//           const res = await fetch(fileData);
//           arrayBuffer = await res.arrayBuffer();
//         }

//         const tempPdf = await PDFDocument.load(arrayBuffer);
//         const copiedPages = await mergedPdf.copyPages(
//           tempPdf,
//           tempPdf.getPageIndices()
//         );

//         copiedPages.forEach((page) => mergedPdf.addPage(page));
//       } catch (err) {
//         console.error("Merge error:", err);
//         toast.error("Some reports could not be merged");
//       }
//     }

//     if (mergedPdf.getPageCount() === 0) {
//       toast.error("No valid reports found");
//       return;
//     }

    
//     const mergedPdfBytes = await mergedPdf.save();
//     const mergedBlob = new Blob([mergedPdfBytes], {
//       type: "application/pdf",
//     });

//     const today = new Date().toLocaleDateString("en-GB").replace(/\//g, "-");
//     const patientName =
//       reports[0]?.PatientName?.replace(/\s+/g, "_") || "Patient";

    
//     saveAs(mergedBlob, `${patientName}_${today}.pdf`);
//     toast.success("All reports merged successfully!");
//   } catch (err) {
//     console.error(err);
//     toast.error("Failed to merge reports");
//   } finally {
//     setLoading(false);
//   }
// };
const handleDownloadAllReports = async (reports) => {
  setLoading(true);

  try {
    const mergedPdf = await PDFDocument.create();
    const processedUrls = new Set();

    for (const report of reports) {
      /* -------------------------------
         1️⃣ MAIN REPORT PDF
      -------------------------------- */
      if (report.report_image_url && !processedUrls.has(report.report_image_url)) {
        processedUrls.add(report.report_image_url);

        const resp = await getBillIdWiseDownload({
          printUrl: report.report_image_url,
        });

        if (resp?.data?.status === "success" && resp.data.data) {
          let buffer;

          if (resp.data.data.startsWith("data:")) {
            const base64 = resp.data.data.split(",")[1];
            buffer = Uint8Array.from(atob(base64), c => c.charCodeAt(0)).buffer;
          } else {
            buffer = await (await fetch(resp.data.data)).arrayBuffer();
          }

          const pdf = await PDFDocument.load(buffer);
          const pages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
          pages.forEach(p => mergedPdf.addPage(p));
        }
      }

      /* -------------------------------
         2️⃣ IMAGE FILES (JPG / PNG / PDF)
      -------------------------------- */
      if (Array.isArray(report.Image_files_url)) {
        for (const img of report.Image_files_url) {
          if (!img.ImageFile || processedUrls.has(img.ImageFile)) continue;
          processedUrls.add(img.ImageFile);

          if (img.ImageFile.toLowerCase().endsWith(".pdf")) {
            const buffer = await (await fetch(img.ImageFile)).arrayBuffer();
            const pdf = await PDFDocument.load(buffer);
            const pages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
            pages.forEach(p => mergedPdf.addPage(p));
          } else {
            await embedImageToPdf(mergedPdf, img.ImageFile);
          }
        }
      }
    }

    if (mergedPdf.getPageCount() === 0) {
      toast.error("No valid reports found");
      return;
    }

    /* -------------------------------
       FINAL DOWNLOAD
    -------------------------------- */
    const pdfBytes = await mergedPdf.save();
    const blob = new Blob([pdfBytes], { type: "application/pdf" });

    const patientName =
      reports[0]?.PatientName?.replace(/\s+/g, "_") || "Patient";
    const today = new Date().toLocaleDateString("en-GB").replace(/\//g, "-");

    saveAs(blob, `${patientName}_${today}.pdf`);
    toast.success("All reports downloaded as single PDF!");
  } catch (err) {
    console.error(err);
    toast.error("Failed to download reports");
  } finally {
    setLoading(false);
  }
};

 if (loading) return <CustomLoader />;

if (!reports || reports.length === 0) {
  return (
    <Typography variant="body1" textAlign="center" mt={3}>
      No reports found.
    </Typography>
  );
}
  // Take bill-level details from the first object
  const billDetails = {
    billId: reports[0].BillID,
    billDate: reports[0].BillDate,
    netAmount: reports[0].NetAmt,
    dueAmount: reports[0].DueAmt,
    patientName: reports[0].PatientName,
    billPdfUrl: reports[0].Bill_pdf_url,
    patientName: reports[0].PatientName,
    user_id: reports[0].user_id,
    prescriptionUrl: reports[0].Prescription_pdf_url,
  };

  const handleOpenImageModal = (files) => {
    setSelectedFiles(files);
    setOpenImageModal(true);
  };

  const handleCloseImageModal = () => {
    setOpenImageModal(false);
    setSelectedFiles([]);
  };

  // Utility function: group by report_image_url
  const groupReportsByImage = (reports) => {
    const grouped = {};

    reports.forEach((test) => {
      if (test.report_image_url) {
        if (!grouped[test.report_image_url]) {
          grouped[test.report_image_url] = [];
        }
        grouped[test.report_image_url].push(test.TestName);
      }
    });

    return grouped;
  };
  const groupedReports = groupReportsByImage(reports);

  const fetchGraphData = async () => {
    setLoading(true);
    try {
      const payload = {
        RBAuthKey: "RBDWAh!Q1s74e",
        User_Id: billDetails.user_id,
      };
      const response = await getGraphData(payload);
      setGraphData(response?.data?.data || []);
      setShowGraphList(true);
      console.log("Graph Data:", response);
    } catch (error) {
      console.error("Error fetching graph data:", error);
    } finally {
      setLoading(false);
    }
  };

  const FetchGraphDetails = async (testData) => {
    console.log("Fetching graph details for test:", testData);
    setUserId(testData.User_ID);
    try {
      const payload = {
        RBAuthKey: "RBDWAh!Q1s74e",
        user_id: testData.User_ID.slice(-6),
      };
      setLoading(true);
      const response = await getGraphDetails(payload);
      const filterList = response?.data?.data;
      const filteredData = filterList.filter(
        (item) => item.CompoID === testData.CompoID
      );
      console.log("Filtered Graph Details:", filteredData);
      setGraphDetails(filteredData);
      setGraphModal(true);
    } catch (error) {
      console.error("Error fetching graph data:", error);
    } finally {
      setLoading(false);
    }
  };

  // const handleViewPdf = () => {
  //   const testName = graphDetails[0]?.TestName ;
  //   const patientId = userId;
  //   const url = `https://rb-api.in:4436/RBReports/RB_Patient_Data/GRAPH/${patientId}/${testName}.pdf`;
  //   window.open(url, "_blank");
  // }

  const handleViewPdf = () => {
    if (!graphDetails || graphDetails.length === 0) return;

    const rawTestName = graphDetails[0]?.TestName || "";
    const safeTestName = rawTestName.replace(/\s+/g, "_"); // replace spaces with "_"
    const patientId = userId;

    const url = `https://rb-api.in:4436/RBReports/RB_Patient_Data/GRAPH/${patientId}/${safeTestName}.pdf`;
    window.open(url, "_blank");
  };

 


  return (
    <Box p={3}>
      {/* Top Card Section */}
      <Card
        sx={{
          mb: 3,
          borderRadius: 3,
          boxShadow: 3,
          bgcolor: "#E6F7F5",
          position: "relative",
        }}
      >
        {/* Top-left alert box */}
        {billDetails.dueAmount === "0.00" && (
        <Box
          sx={{
            position: "absolute",
            top: 16,
            left: 16,

            color: "#FF8C00",
            px: 2,
            py: 1,

            display: "flex",
            alignItems: "center",
            cursor: "pointer",

            zIndex: 10,
          }}
          onClick={() => {
            window.open(
              "https://rbdiagnostic.com/rb_merge_tabview/merge/frontview",
              "_blank"
            );
          }}
        >
          <Typography variant="body2" sx={{ fontWeight: "bold" }}>
            Unable to find your past readings?{" "}
            <span style={{ textDecoration: "underline", color: "#0FB7A4" }}>
              Click here
            </span>
          </Typography>
        </Box>
        )}
        <CardContent>
          <Grid container direction="column" alignItems="center" spacing={2}>
            <Grid item></Grid>
            {/* Patient Name */}
            <Grid item>
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", textAlign: "center", color: "grey" }}
              >
                {billDetails.patientName}
              </Typography>
            </Grid>

            {/* Bill Info in a Row */}
            <Grid item xs={12}>
              <Grid container spacing={3} justifyContent="space-between">
                <Grid item>
                  <Typography variant="body2">
                    <strong>Bill Id :</strong> {billDetails.billId}
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography variant="body2">
                    <strong>Bill Date :</strong> {billDetails.billDate}
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography variant="body2">
                    <strong>Net Amt(Rs.) :</strong> {billDetails.netAmount}
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography variant="body2">
                    <strong>Due Amt(Rs.) :</strong> {billDetails.dueAmount}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            {/* Buttons Row */}
            <Grid item>
              <Grid container spacing={2} justifyContent="center">
                <Grid item>
                  <Button
                    variant="contained"
                    sx={{
                      textTransform: "none",
                      borderRadius: 2,
                      bgcolor: "#0FB7A4",
                    }}
                    onClick={() => navigate("/view-reports")} 
                  >
                    Search New
                  </Button>
                </Grid>
                {billDetails.dueAmount === "0.00" && (
                <Grid item>
                  <Button
                    variant="contained"
                    target="_blank"
                    sx={{
                      textTransform: "none",
                      borderRadius: 2,
                      bgcolor: "#0FB7A4",
                    }}
                    onClick={fetchGraphData}
                  >
                    View Graph
                  </Button>
                </Grid>
                )}
                <Grid item>
                  <Button
                    variant="contained"
                    href={billDetails.billPdfUrl}
                    target="_blank"
                    sx={{
                      textTransform: "none",
                      borderRadius: 2,
                      bgcolor: "#0FB7A4",
                    }}
                  >
                    View Bill
                  </Button>
                </Grid>
                <Grid item>
                  {billDetails.dueAmount > 0 && (
                    <Button
                      variant="contained"
                      sx={{
                        textTransform: "none",
                        borderRadius: 2,
                        bgcolor: "#0FB7A4",
                      }}
                      onClick={handlePayNow}
                    >
                      Pay Now
                    </Button>
                  ) }
                   </Grid>
                  {billDetails.prescriptionUrl && (
                    <Button
                      variant="contained"
                      component="a"
                      href={encodeURI(billDetails.prescriptionUrl)}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{
                        textTransform: "none",
                        borderRadius: 2,
                        bgcolor: "#0FB7A4",
                      }}
                    >
                      View Rx
                    </Button>
                  )}
               
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Table Section */}
      <TableContainer component={Paper} sx={{ borderRadius: 3, boxShadow: 3 }}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#0FB7A4" }}>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                Test Name
              </TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                Status
              </TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                Test Result
              </TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                Ref.Range
              </TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                PACs
              </TableCell>

              <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                Graph/Img
              </TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                Report Image
              </TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                Reports
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {reports.map((test, idx) => (
              <TableRow
                key={idx}
                sx={{
                  backgroundColor: idx % 2 === 0 ? "#ffffff" : "#E6F7F5", // alternate light teal
                  "&:hover": { backgroundColor: "#D9F2EE" }, // slightly deeper on hover
                }}
              >
                <TableCell>{test.TestName || "-"}</TableCell>
                <TableCell>{test.ReportStatus || "-"}</TableCell>
                <TableCell>
                  {test.Test_Results?.length > 0
                    ? test.Test_Results.map((res, i) => (
                        <div key={i}>
                          {res.Component} - {res.TestResult}
                        </div>
                      ))
                    : "-"}
                </TableCell>
                <TableCell>
                  {test.Test_Results?.length > 0
                    ? test.Test_Results.map((res, i) => (
                        <div key={i}>{res.RefRange}</div>
                      ))
                    : "-"}
                </TableCell>

                <TableCell>
                  {test?.PacksLinkID && Number(test.PacksLinkID) !== 0 ? (
                    <Typography
                      component="a"
                      href={`https://rbdiagnostic.com/form?id=${btoa(
                        test.BillID
                      )}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{
                        fontWeight: "bold",
                        color: "#0FB7A4",
                        textDecoration: "none",
                        cursor: "pointer",
                        "&:hover": { textDecoration: "underline" },
                      }}
                    >
                      YES
                    </Typography>
                  ) : (
                    ""
                  )}
                </TableCell>

                <TableCell>
                  {test?.Attachment_url ? (
                    <a
                      href={test.Attachment_url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      YES
                    </a>
                  ) : (
                    "-"
                  )}
                </TableCell>
                <TableCell>
                  {test.Image_files_url?.length > 0 ? (
                    <Typography
                      sx={{
                        color: "#0FB7A4",
                        fontWeight: "bold",
                        cursor: "pointer",
                      }}
                      onClick={() => handleOpenImageModal(test.Image_files_url)}
                    >
                      YES
                    </Typography>
                  ) : (
                    "-"
                  )}
                </TableCell>
                {/* <TableCell>
                  {test.report_image_url ? (
                    <a
                      href={test.report_image_url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View
                    </a>
                  ) : (
                    "-"
                  )}
                </TableCell> */}
                <TableCell>
                  {test.report_image_url ? (
                    <a
                      style={{
                        color: "#0FB7A4",
                        textDecoration: "none",
                        cursor: "pointer",
                      }}
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        // Scroll to last row in the table
                        const allRows =
                          document.querySelectorAll("table tbody tr");
                        if (allRows.length > 0) {
                          const lastRow = allRows[allRows.length - 1];
                          lastRow.scrollIntoView({ behavior: "smooth" });
                        }
                      }}
                    >
                      View
                    </a>
                  ) : (
                    "-"
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        {/* {reports?.length > 0 &&
          !reports.some((item) => item.ReportStatus === "Pending") && ( */}
          {billDetails.dueAmount === "0.00" && (
            <Card sx={{ mt: 3, p: 2 }}>
              <Typography
                variant="h6"
                sx={{ color: "#0FB7A4", fontWeight: "bold", mb: 1 }}
              >
                View Report :{" "}
                <Typography
                  component="a"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    textDecoration: "none",
                    color: "#0FB7A4",
                    fontWeight: "normal",
                    ml: 1,
                    display: "inline-flex",
                    alignItems: "center",
                    cursor: "pointer",
                    "&:hover": { textDecoration: "underline" },
                  }}
                  onClick={() => handleDownloadAllReports(reports)}
                >
                  <DownloadIcon />
                  Download All Reports
                </Typography>
              </Typography>
              {/* {Object.entries(groupedReports).map(([url, testNames], idx) => (
            <Box
              key={idx}
              sx={{
                display: "flex",
                alignItems: "center",
                mb: 1,
                color: "#0FB7A4",
              }}
            >
              
              <CheckCircleIcon fontSize="small" sx={{ mr: 1 }} />

             
              <Typography variant="body2" sx={{ flexGrow: 1 }}>
                {testNames.join(", ")}
              </Typography>

              
              <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#0FB7A4",  }}
              >
                <PictureAsPdfIcon fontSize="small" />
              </a>
            </Box>
          ))} */}

              {Object.entries(groupedReports).map(([url, testNames], idx) => (
                <Box
                  key={idx}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mb: 1,
                    color: "#0FB7A4",
                  }}
                >
                  {/* Green check icon */}
                  <CheckCircleIcon fontSize="small" sx={{ mr: 1 }} />

                  {/* Test names with PDF icon beside */}
                  <a
                    href={url}
                    target="_blank"
                    download
                    style={{
                      color: "#0FB7A4",
                      display: "flex",
                      alignItems: "center",
                      textDecoration: "none",
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
                    >
                      {testNames.join(", ")}

                      {/* PDF Icon for download */}

                      <PictureAsPdfIcon fontSize="small" />
                    </Typography>
                  </a>
                </Box>
              ))}
            </Card>
          )}
      </TableContainer>

      {openModal && (
        <PaymentModal
          open={openModal}
          //   onClose={handleClose}
          billDetails={billDetails}
        />
      )}

      {openImageModal && (
        <ReportImageModal
          open={openImageModal}
          onClose={handleCloseImageModal}
          files={selectedFiles}
        />
      )}
      {showGraphList ? (
        <GraphList
          open={showGraphList}
          onClose={() => setShowGraphList(false)}
          data={graphData}
          patientName={billDetails.patientName}
          handleViewGraph={FetchGraphDetails}
        />
      ) : loading ? (
        <CustomLoader />
      ) : null}

      {graphModal && (
        <GraphDetailsModal
          open={graphModal}
          onClose={() => setGraphModal(false)}
          data={graphDetails}
          patientName={billDetails.patientName}
          handleViewPdf={handleViewPdf}
        />
      )}
    </Box>
  );
};

export default ShowReport;
